import { PaymentMethod } from 'src/types';

import classNames from 'classnames';
import { CardPaymentMethod } from './components/CardPaymentMethod';
import { memo } from 'react';
import { Skeletons } from 'src/components/Skeletons';

interface PaymentMethods {
  onSelectPaymentMethod?: (method: PaymentMethod) => void;
  selectedMethod?: number;
  methods: PaymentMethod[];
  isLoading: boolean;
}

const _PaymentMethods = ({ onSelectPaymentMethod, selectedMethod, methods }: PaymentMethods) => {
  const paymentMethods = methods.filter(({ type }) => type !== 'coin');

  return (
    <div className="flex">
      <div
        className={classNames(
          'flex flex-wrap justify-center items-center gap-1 768:gap-5 py-2.5 768:py-5 relative z-0',
          paymentMethods.length > 3 ? 'flex-1' : ''
        )}>
        {paymentMethods.length === 0 ? (
          <Skeletons count={12} className="w-[75px] 412:w-[85px] h-[85px]" />
        ) : (
          paymentMethods.map((method, index) => {
            return (
              <CardPaymentMethod
                key={method._reactDepositMethodId}
                method={method}
                onClick={onSelectPaymentMethod}
                selected={Boolean(method._reactDepositMethodId === selectedMethod)}
                id={`${index}`}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export const PaymentMethods = memo(_PaymentMethods);
